export default [
  "Contrôle des réservations",
  "Passage OA",
  "Visite chantier",
  "Alerte accès chantier",
];
